var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ff8c08",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 245 256",
    enableBackground: "new 0 0 245 256",
    xmlSpace: "preserve",
    stroke: "#ff8c08",
    strokeWidth: 0.00245,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190,63.24V7h-31v27.73L122.97,1.82L1.94,110.15l18.4,20.74L39,114.04V254h167V115.08l18.36,16.85l18.89-20.22L190,63.24z M162.96,169.32c-6.88,6.87-16.46,9.29-25.26,7.38l-9.08,9.08l-14.86-3.01l1.52,13.24l-11.4-2.93l1.52,13.1l-11.76-3l1.45,13.31 l-20.58,1.48L74,198.44l42.83-42.83c-1.84-8.72,0.65-18.24,7.45-25.04c10.68-10.67,27.93-10.78,38.68-0.03 C173.7,141.28,173.66,158.61,162.96,169.32z M149.64,135.31c-2.38,2.39-2.35,6.26,0,8.61c2.35,2.35,6.19,2.43,8.61,0 c2.39-2.39,2.39-6.22,0-8.61C155.87,132.92,152.03,132.92,149.64,135.31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRent);
export default __webpack_public_path__ + "static/media/rent.fb44b79448bd0643cd9bc7f58558b227.svg";
export { ForwardRef as ReactComponent };